import React from "react";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { makeStyles } from "tss-react/mui";
import { IconButton } from "../button/Buttons.js";
import "../button/EditButton.js";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { Icon, IconColor } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import { ExpandMoreMinusIcon, ExpandMorePlusIcon } from "../icons/ExpandMoreIcon.js";
const useStyles = makeStyles()((theme, _params, classes) => ({
  treeViewItemExpandableOption: {
    "& .MuiTreeItem-root": {
      position: "relative",
      "&:hover": {
        background: theme.palette.primary.light
      }
    }
  },
  treeViewItemExpandableOptionIcon: {
    display: "none"
  },
  treeViewItemExpandableOptionLabel: {
    "& .MuiTreeItem-content": {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      "& .MuiTreeItem-label": {
        position: "static"
      }
    }
  },
  treeViewItemExpandableOptionLabelContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  treeViewItemExpandableOptionContentLines: {
    position: "relative",
    "&:before, &:after": {
      content: '""',
      position: "absolute",
      zIndex: "1",
      left: theme.spacing(1.5)
    },
    "&:after": {
      bottom: "50%",
      height: "100%",
      width: theme.spacing(2),
      borderLeft: `1px solid ${theme.custom.palette.content.border}`,
      borderBottom: `1px solid ${theme.custom.palette.content.border}`
    },
    "&:before": {
      width: 1,
      height: 0,
      borderLeft: `1px solid ${theme.custom.palette.content.border}`
    }
  },
  treeViewItemExpandableOptionContentLinesLastChild: {
    "&:before": {
      height: "100%"
    }
  },
  treeViewItemExpandableOptionSelected: {
    "& .MuiTreeItem-root": {
      background: theme.palette.primary.light,
      [`& .${classes.treeViewItemExpandableOptionIcon}`]: {
        display: "block"
      }
    }
  },
  treeViewItemExpandableOptionDepthLines: {
    display: "flex",
    justifyContent: "space-between",
    position: "absolute",
    top: 0,
    height: "100%",
    marginLeft: theme.spacing(1.5)
  },
  treeViewItemExpandableOptionDepthLineMargin: {
    width: theme.spacing(2),
    height: "100%"
  },
  treeViewItemExpandableOptionDepthLine: {
    borderLeft: `1px solid ${theme.custom.palette.content.border}`
  }
}));
function TreeViewItemExpandableOption({
  label,
  itemId,
  onClick,
  onExpand,
  style,
  parentsDepthLines,
  depth = 0,
  isSelected = false,
  hasSubOptions = false,
  isExpanded = false,
  isLastChild = false,
  ...props
}) {
  const { classes, cx, theme } = useStyles();
  function handleClick() {
    onClick(label);
  }
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(classes.treeViewItemExpandableOption, classes.treeViewItemExpandableOptionLabel, {
        [classes.treeViewItemExpandableOptionSelected]: isSelected
      })
    },
    /* @__PURE__ */ React.createElement(
      TreeItem,
      {
        classes: {
          content: cx({
            [classes.treeViewItemExpandableOptionContentLines]: !!depth,
            [classes.treeViewItemExpandableOptionContentLinesLastChild]: !isLastChild
          })
        },
        slots: {
          icon: () => hasSubOptions ? isExpanded ? /* @__PURE__ */ React.createElement(IconButton, { onClick: onExpand }, /* @__PURE__ */ React.createElement(ExpandMoreMinusIcon, null)) : /* @__PURE__ */ React.createElement(IconButton, { onClick: onExpand }, /* @__PURE__ */ React.createElement(ExpandMorePlusIcon, null)) : null
        },
        itemId,
        onClick: handleClick,
        label: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: classes.treeViewItemExpandableOptionDepthLines,
            style: {
              left: `-${parseInt(theme.spacing(2), 10) * depth}px`
            }
          },
          parentsDepthLines?.map((i) => /* @__PURE__ */ React.createElement(
            "div",
            {
              className: cx(
                {
                  [classes.treeViewItemExpandableOptionDepthLine]: i
                },
                classes.treeViewItemExpandableOptionDepthLineMargin
              )
            }
          ))
        ), /* @__PURE__ */ React.createElement("div", { className: classes.treeViewItemExpandableOptionLabelContainer }, /* @__PURE__ */ React.createElement(LocalizedText, { label }), isSelected ? /* @__PURE__ */ React.createElement(
          Icon,
          {
            icon: CustomIcon.Confirm,
            color: IconColor.Primary,
            className: classes.treeViewItemExpandableOptionIcon
          }
        ) : null)),
        style: { ...style, paddingLeft: `${parseInt(theme.spacing(2), 10) * depth}px` },
        ...props
      }
    )
  );
}
export {
  TreeViewItemExpandableOption
};
//# sourceMappingURL=TreeViewItemExpandableOption.js.map
